module.exports = __webpack_public_path__ + "img/analytics.66a55e73.png";